import { B2CPolicy, IEnvironmentVariables } from './IEnvironment';

export const b2cPolicies: B2CPolicy = {
  names: {
    signUpSignIn: 'B2C_1A_Signup_Signin',
    forgotPassword: 'B2C_1A_PasswordReset'
  },
  authorityBaseUrl: 'https://mncportalqat.b2clogin.com/tfp/mncportalqat.onmicrosoft.com'
};

export const environment: IEnvironmentVariables = {
  commonDomainEmailNoteReleaseDate: '2025-09-01T00:00:00Z',
  b2cPolicies: b2cPolicies,
  production: true,
  buildNumber: '_BUILDNUMBER_',
  version: '_VERSION_',
  baseUrl: 'https://usermgmt.portalqat.mynexuscare.com/',
  apiUrl: 'https://api-homehealth.portalqat.mynexuscare.com',
  platformApiUrl: 'https://api-platform.portalqat.mynexuscare.com',
  registryUrl: `https://api-platform.portalqat.mynexuscare.com/api/app-registry`,
  authConfig: {
    config: {
      auth: {
        clientId: 'a8044264-7310-4f2b-b77b-b6d3ce68b06f',
        postLogoutRedirectUri: 'https://usermgmt.portalqat.mynexuscare.com/login',
        redirectUri: 'https://usermgmt.portalqat.mynexuscare.com/login',
        knownAuthorities: ['mncportalqat.b2clogin.com'],
        authority: `${b2cPolicies.authorityBaseUrl}/${b2cPolicies.names.signUpSignIn}`,
        navigateToLoginRequestUrl: false,
      },
    },
    angularConfig: {
      consentScopes: [
        'https://mncportalqat.onmicrosoft.com/api/api.Write',
        'https://mncportalqat.onmicrosoft.com/api/api.Read',
        'https://mncportalqat.onmicrosoft.com/api/user_impersonation',
      ],
      protectedResourceMap: [
        [
          'https://api-homehealth.portalqat.mynexuscare.com/',
          [
            'https://mncportalqat.onmicrosoft.com/api/api.Write',
            'https://mncportalqat.onmicrosoft.com/api/api.Read',
            'https://mncportalqat.onmicrosoft.com/api/user_impersonation',
          ]
        ],
        [
          'https://api-platform.portalqat.mynexuscare.com/',
          [
            'https://mncportalqat.onmicrosoft.com/api/api.Write',
            'https://mncportalqat.onmicrosoft.com/api/api.Read',
            'https://mncportalqat.onmicrosoft.com/api/user_impersonation',
          ]
        ]
      ]
    }
  }
};
